export function extractNumFromStr (str) {
  // var tName = location.pathname;
  var numbersFromString=str.match(/\d+/g);
  return numbersFromString;
}

export function alertMe(){
  alert("test")
}